module.exports = __webpack_public_path__ + "img/Alchimeia_closed.ba94ba1a.png";